import {
    isScreenAtLeast,
    debounce,
} from '../../../common/utils';

import els from './elements';

let context = null;

const adjustLineX = () => {

    const $line = els.$eventsLine();
    const $points = els.$eventsPoints();
    const $point = $points.first();

    const offset = (
        ($line.offset().left + ($line.width() * 0.5))
        - ($point.offset().left + ($point.width() * 0.5))
    );

    gsap.set(
        $line,
        { left: `-=${offset}` }
    );
};

const adjustLineY = () => {

    const $wrap = els.$eventsWrap();
    const $line = els.$eventsLine();
    const $points = els.$eventsPoints();
    const $point = $points.first();

    const offset = (
        ($line.offset().top + ($line.height() * 0.5))
        - ($point.offset().top + ($point.height() * 0.5))
    );

    gsap.set(
        $wrap,
        { y: `+=${offset}` }
    );
};

const prepareHeadingAnimation = () => {

    const $story = els.$story();
    const $heading = els.$timelineHeading();

    gsap.fromTo(
        $heading,
        {
            autoAlpha: 0,
        },
        {
            autoAlpha: 1,
            duration: 0.75,
            ease: 'power4.inOut',
            scrollTrigger: {
                trigger: $heading,
                start: 'top 80%',
                pinnedContainer: $story,
            },
        }
    );
};

const preparePoleAnimation = () => {

    const $story = els.$story();
    const $pole = els.$timelinePole();

    gsap.set($pole, { xPercent: -100 });
    gsap.set($pole, { autoAlpha: 1 });

    gsap.fromTo(
        $pole,
        {
            x: -10000,
        },
        {
            x: 0,
            duration: 0.75,
            ease: 'power4.inOut',
            scrollTrigger: {
                trigger: $pole,
                start: 'top 80%',
                pinnedContainer: $story,
            },
        }
    );
};

const prepareLineAnimation = () => {

    const $story = els.$story();
    const $line = els.$eventsLine();

    if (isScreenAtLeast('md')) {

        const lineWidth = $line.preciseWidth();

        gsap.fromTo(
            $line,
            {
                width: 0,
            },
            {
                width: lineWidth,
                ease: 'power2.inOut',
                duration: 1,
                scrollTrigger: {
                    trigger: $line,
                    start: 'top 90%',
                    pinnedContainer: $story,
                },
            }
        );

    } else {

        const lineHeight = $line.preciseHeight();

        gsap.fromTo(
            $line,
            {
                height: 0,
            },
            {
                height: lineHeight,
                ease: 'power2.inOut',
                duration: 1,
                scrollTrigger: {
                    trigger: $line,
                    start: 'top 90%',
                    pinnedContainer: $story,
                },
            }
        );
    }

    gsap.set($line, { autoAlpha: 1 });
};

const prepareEventsAnimations = () => {

    const $story = els.$story();
    const $eventsWrap = els.$eventsWrap();
    const $events = els.$events();

    if (isScreenAtLeast('md')) {

        gsap.fromTo(
            $events,
            {
                y: 100,
                autoAlpha: 0,
            },
            {
                y: 0,
                autoAlpha: 1,
                duration: 0.75,
                stagger: 0.25,
                scrollTrigger: {
                    trigger: $eventsWrap,
                    start: 'top 80%',
                    duration: 0.75,
                    pinnedContainer: $story,
                },
            }
        );
    } else {

        $events.each((_, element) => {

            gsap.fromTo(
                element,
                {
                    yPercent: 50,
                    autoAlpha: 0,
                },
                {
                    yPercent: 0,
                    autoAlpha: 1,
                    duration: 0.75,
                    ease: 'power4.inOut',
                    scrollTrigger: {
                        trigger: element,
                        start: 'top 80%',
                        duration: 0.75,
                    },
                }
            );
        });

    }

    gsap.set($eventsWrap, { autoAlpha: 1 });
};

const prepareAnimation = () => {

    context = gsap.context(() => {

        prepareHeadingAnimation();

        prepareEventsAnimations();

        prepareLineAnimation();

        preparePoleAnimation();
    });
};

const prepare = () => {

    if (isScreenAtLeast('md')) {
        adjustLineY();
    } else {
        adjustLineX();
    }

    prepareAnimation();
};

const cleanUp = () => {

    context?.revert();

    gsap.set(
        els.$eventsLine(),
        { clearProps: 'all' }
    );

    gsap.set(
        els.$eventsWrap(),
        { clearProps: 'all' }
    );
};

const initialize = () => {

    prepare();

    $(window).on(
        'resize:horizontally',
        debounce(
            () => {
                cleanUp();
                prepare();
            },
            100
        )
    )
    window.adjustLineY = adjustLineY;
};

export default {
    initialize,
};

